import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './style.scss';

class LinkBox extends Component {
  render = () => (
    <div>
      {this.props.internal && (
        <Link to={this.props.link}>
          <div className="col-sm-6 col-md-6 col-lg-2 box">
            <div
              className={`card ${this.props.selected ? 'selected-card' : ''}`}
            >
              <div className="text-right">
                <i className={`${this.props.icon}  icon`} />
              </div>
              <div className="card-body">
                <p
                  className={`title ${
                    this.props.selected ? 'text-selected' : ''
                  }`}
                >
                  {this.props.title}
                </p>
                <p className="description">{this.props.description}</p>
              </div>
            </div>
          </div>
        </Link>
      )}
      {!this.props.internal && (
        <a href={this.props.link} target="_blank">
          <div className="col-sm-6 col-md-6 col-lg-2 box">
            <div
              className={`card ${this.props.selected ? 'selected-card' : ''}`}
            >
              <div className="text-right">
                <i className={`${this.props.icon}  icon`} />
              </div>
              <div className="card-body">
                <p
                  className={`title ${
                    this.props.selected ? 'text-selected' : ''
                  }`}
                >
                  {this.props.title}
                </p>
                <p className="description">{this.props.description}</p>
              </div>
            </div>
          </div>
        </a>
      )}
    </div>
  );
}

export default LinkBox;
